import { Col, Row, TabPanel } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { Typography } from '@paypalcorp/ppods-react'
import React from 'react'

import PayoutsStandardImg from '../../../../img/payment-solutions/ill_Payouts.png'
import PayoutsLargeBatchImg from '../../../../img/payment-solutions/ill_largeBatch.png'
import PayoutsWebImg from '../../../../img/payment-solutions/ill_payoutsWeb.png'
import { saveBannerProgress } from '../../../../utils/session-utils'
import { useApplicationContext } from '../../../../context/ApplicationContext'

export default function Payouts({ setBannerPage, setProductIntegration }) {
  const { csrf, logger, setCurrentBannerStep } = useApplicationContext()
  return (
    <>
      <TabPanel id="group4-panel3" tabId="group1-panel3">
        <Row className="onboarding-banner-cards-row">
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'stdPayouts',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('stdPayouts')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={PayoutsStandardImg}
              />
              <br />
              <Typography variant="title" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabThree.productOne" />
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabThree.productOneDesc" />
              </Typography>
            </div>
          </Col>
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'batchPayouts',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('batchPayouts')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={PayoutsLargeBatchImg}
              />
              <br />
              <Typography variant="title" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabThree.productTwo" />
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabThree.productTwoDesc" />
              </Typography>
            </div>
          </Col>
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'webPayouts',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('webPayouts')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={PayoutsWebImg}
              />
              <br />
              <Typography variant="title" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabThree.productThree" />
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabThree.productThreeDesc" />
              </Typography>
            </div>
          </Col>
        </Row>
      </TabPanel>
    </>
  )
}
